// A stale fair-market value of the previous variant must not reach the lead (CMS-2047).
export const EMPTY_FROM_VARIANT = { fairMarket: 0 };
export const EMPTY_FROM_YEAR = { ...EMPTY_FROM_VARIANT, trim: '' };
// Top-down cascade on Moneymax: a make or model change also empties the year (CMS-2047).
export const EMPTY_FROM_MODEL = { ...EMPTY_FROM_YEAR, manufactureYear: '' };
export const EMPTY_FROM_MAKE = {
  ...EMPTY_FROM_MODEL,
  modelCode: '',
  modelName: '',
};
